// import React, { useEffect, useState, useRef } from "react";
// import { jwtDecode } from "jwt-decode";
// import "./ChatBoard.css";
// import Navbar from "../common/Navbar";
// import Footer from "../common/Footer";
// import io from "socket.io-client";
// import Sideboard from "./Sideboard";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";
// import EmojiPicker from "emoji-picker-react"; // Import the emoji picker
// import {
//   Box,
//   Typography,
//   InputBase,
//   Select,
//   MenuItem,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Card,
//   CardHeader,
//   CardContent,
//   CardActions,
//   Avatar,
// } from "@mui/material";
// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const ChatBoard = () => {
//   const [messages, setMessages] = useState([]);
//   const [newMessage, setNewMessage] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [userId, setUserId] = useState(null);
//   const [socket, setSocket] = useState(null);
//   const [receiverId, setReceiverId] = useState(null);
//   const [employees, setEmployees] = useState([]);
//   const [groups, setGroups] = useState([]);
//   const [showEmojiPicker, setShowEmojiPicker] = useState(false); // State for emoji picker visibility
//   const [files, setFiles] = useState([]); // New state for files
//   const [selectedFiles, setSelectedFiles] = useState([]); // Files selected for upload
//   const reactQuillRef = useRef(null); // Create a reference to the ReactQuill component

//   useEffect(() => {
//     const socketInstance = io(BASE_URL);
//     setSocket(socketInstance);

//     socketInstance.on("newMessage", (messageData) => {
//       setMessages((prevMessages) => [...prevMessages, messageData.message]);
//     });

//     return () => {
//       if (socketInstance) socketInstance.disconnect();
//     };
//   }, []);

//   useEffect(() => {
//     const fetchEmployees = async () => {
//       try {
//         const token = sessionStorage.getItem("token");
//         const response = await fetch(`${BASE_URL}/api/employees/`, {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         });

//         if (!response.ok) throw new Error("Error fetching employees");
//         const data = await response.json();
//         setEmployees(data);
//       } catch (err) {
//         console.error("Error fetching employees:", err);
//         setError("Error fetching employees");
//       }
//     };

//     const fetchGroups = async () => {
//       try {
//         const token = sessionStorage.getItem("token");
//         const response = await fetch(`${BASE_URL}/api/chat/getallgroups`, {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         });

//         if (!response.ok) throw new Error("Error fetching groups");

//         const data = await response.json();
//         setGroups(Array.isArray(data.data) ? data.data : []);
//       } catch (err) {
//         console.error("Error fetching groups:", err);
//         setError("Error fetching groups");
//       }
//     };

//     fetchEmployees();
//     fetchGroups();
//   }, []);

//   const fetchMessages = async () => {
//     if (!receiverId) return;

//     setLoading(true);
//     const token = sessionStorage.getItem("token");
//     const decodedToken = jwtDecode(token);
//     const senderId = decodedToken.employee.id;

//     try {
//       const response = await fetch(
//         `${BASE_URL}/api/chat/getChat/${senderId}/${receiverId}`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.ok) throw new Error("Error fetching messages");

//       const result = await response.json();

//       if (
//         result.status === 1 &&
//         result.data &&
//         Array.isArray(result.data.messages)
//       ) {
//         setMessages(result.data.messages);
//       } else {
//         setMessages([]);
//       }

//       setUserId(senderId);
//     } catch (err) {
//       console.error("Error fetching chat messages:", err);
//       setError("Error fetching chat messages");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchMessages();
//   }, [receiverId]);

//   const sendMessage = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     const token = sessionStorage.getItem("token");

//     try {
//       const decodedToken = jwtDecode(token);
//       const senderId = decodedToken.employee.id;
//       const senderName = decodedToken.employee.name;

//       if (
//         !senderId ||
//         !receiverId ||
//         (!newMessage && selectedFiles.length === 0)
//       ) {
//         throw new Error(
//           "Sender ID, receiver ID, and either message or files are required"
//         );
//       }

//       const formData = new FormData();
//       formData.append("senderId", senderId);
//       formData.append("receiverId", receiverId);
//       formData.append("message", newMessage);

//       selectedFiles.forEach((file, index) => {
//         formData.append(`files`, file);
//       });

//       // Send the message to the backend
//       const response = await fetch(`${BASE_URL}/api/chat/sendMessage`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//         body: formData,
//       });

//       if (!response.ok) throw new Error("Error sending message");

//       const newMsg = await response.json();

//       // Check if the message is successfully sent before updating the state
//       if (newMsg && newMsg.status === 1) {
//         setMessages((prevMessages) => [...prevMessages, newMsg.data]); // Only update with successful response
//       }

//       socket.emit("sendMessage", newMsg.data); // Emit the message via socket

//       setNewMessage(""); // Clear the message field
//       setSelectedFiles([]); // Clear selected files after sending
//     } catch (err) {
//       console.error("Error sending message:", err);
//       setError("Error sending message");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleFileChange = (e) => {
//     setSelectedFiles(Array.from(e.target.files)); // Convert FileList to an array
//   };

//   const handleEmojiClick = (emoji) => {
//     // Get the current Quill editor instance
//     const quill = reactQuillRef.current.getEditor();

//     // Get the current cursor position
//     const cursorPosition = quill.getSelection()
//       ? quill.getSelection().index
//       : quill.getLength(); // Default to end of the message if no selection

//     // Insert the emoji after the current cursor position
//     quill.insertText(cursorPosition, emoji.emoji);

//     // Move the cursor to the position right after the inserted emoji
//     quill.setSelection(cursorPosition + emoji.emoji.length);

//     setShowEmojiPicker(false); // Close the emoji picker after selection
//   };

//   const formatTime = (timestamp) => {
//     if (!timestamp) return "Unknown time";
//     const date = new Date(timestamp);
//     return date.toLocaleString([], {
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: true,
//     });
//   };

//   return (
//     <>
//       <Navbar />
//             <Box sx={{mt:7 }}>
//       <div className="main-container">
//         <div className="sideboard-container">
//           <Sideboard
//             employees={employees}
//             groups={groups}
//             onSelectChat={setReceiverId}
//           />
//         </div>
//         <div className="chat-board-content">
//           <h2 className="chat-board-title">Chat Board</h2>

//           {loading && <p>Loading...</p>}
//           {error && <p>{error}</p>}

//           <div className="chat-messages">
//             {Array.isArray(messages) && messages.length > 0 ? (
//               messages
//                 .filter(
//                   (message) =>
//                     message.message ||
//                     (message.files && message.files.length > 0)
//                 )
//                 .map((message) => (
//                   <div
//                     key={message._id}
//                     className={`chat-message ${
//                       message.senderId === userId
//                         ? "my-message"
//                         : "other-message"
//                     }`}
//                   >
//                     <div
//                       className={`message-content-wrapper ${
//                         message.senderId === userId ? "right" : "left"
//                       }`}
//                     >
//                       <strong>{message.senderName}</strong>
//                       <div className="message-content">
//                         <p
//                           dangerouslySetInnerHTML={{ __html: message.message }}
//                         ></p>
//                         {message.files &&
//                           message.files.map((file, index) => {
//                             const fileType = file
//                               .split(".")
//                               .pop()
//                               .toLowerCase();
//                             const isImage = [
//                               "jpg",
//                               "jpeg",
//                               "png",
//                               "gif",
//                             ].includes(fileType);
//                             const isVideo = ["mp4", "webm", "ogg"].includes(
//                               fileType
//                             );
//                             const isPDF = fileType === "pdf";

//                             return (
//                               <div key={index} className="file-preview">
//                                 {isImage ? (
//                                   <img
//                                     src={file}
//                                     alt="uploaded"
//                                     className="chat-image"
//                                     onClick={() => window.open(file, "_blank")}
//                                   />
//                                 ) : isVideo ? (
//                                   <div
//                                     className="video-preview-container"
//                                     onClick={() => window.open(file, "_blank")}
//                                   >
//                                     <video
//                                       className="video-thumbnail"
//                                       preload="metadata"
//                                     >
//                                       <source
//                                         src={file}
//                                         type={`video/${fileType}`}
//                                       />
//                                       Your browser does not support the video
//                                       tag.
//                                     </video>
//                                     <div className="video-overlay">
//                                       <span className="play-button">▶</span>
//                                     </div>
//                                   </div>
//                                 ) : isPDF ? (
//                                   <a
//                                     href={file}
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                   >
//                                     <button className="download-button">
//                                       View/Download PDF
//                                     </button>
//                                   </a>
//                                 ) : (
//                                   <a
//                                     href={file}
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                   >
//                                     <button className="download-button">
//                                       Download {file.split("/").pop()}
//                                     </button>
//                                   </a>
//                                 )}
//                               </div>
//                             );
//                           })}
//                       </div>
//                       <div className="message-time">
//                         {formatTime(message.timestamp)}
//                       </div>
//                     </div>
//                   </div>
//                 ))
//             ) : (
//               <p>No messages available</p>
//             )}
//           </div>

//           <form className="chat-input-form" onSubmit={sendMessage}>
//             <div className="emoji-picker-container">
//               <button
//                 type="button"
//                 className="emoji-direct-button"
//                 onClick={() => setShowEmojiPicker((prev) => !prev)}
//               >
//                 😀
//               </button>
//               {showEmojiPicker && (
//                 <EmojiPicker
//                   onEmojiClick={handleEmojiClick}
//                   pickerStyle={{
//                     position: "absolute",
//                     bottom: "50px",
//                     left: "10px",
//                   }}
//                 />
//               )}
//             </div>
//             <div>
//               <ReactQuill
//                 ref={reactQuillRef}
//                 value={newMessage}
//                 onChange={setNewMessage}
//                 placeholder="Type a message..."
//                 modules={{
//                   toolbar: [
//                     [{ header: "1" }, { header: "2" }, { font: [] }],
//                     [{ list: "ordered" }, { list: "bullet" }],
//                     ["bold", "italic", "underline"],
//                     ["link", "image"],
//                     ["blockquote"],
//                     ["code-block"],
//                   ],
//                 }}
//               />
//             </div>
//             <div className="file-input-container">
//               <input
//                 type="file"
//                 multiple
//                 onChange={handleFileChange}
//                 className="file-input"
//               />
//               {selectedFiles.length > 0 && (
//                 <div className="file-list">
//                   {selectedFiles.map((file, index) => (
//                     <div key={index} className="file-item">
//                       {file.name}
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//             <button
//               type="submit"
//               disabled={loading || !newMessage}
//               className="send-button"
//             >
//               Send Message
//             </button>
//           </form>
//         </div>
//       </div>
//       </Box>
//       <Footer />
//     </>
//   );
// };

// export default ChatBoard;



///////////////////////////////////////////////////




















import React, { useEffect, useState, useRef } from "react";
import { jwtDecode } from "jwt-decode";
import Navbar from "../common/Navbar";
import SearchIcon from "@mui/icons-material/Search";

import TextField from "@mui/material/TextField";
import AttachFileIcon from "@mui/icons-material/AttachFile";

import io from "socket.io-client";
import Sideboard from "./Sideboard";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import EmojiPicker from "emoji-picker-react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Paper,
  Stack,
  Input,
  Avatar,
  Badge,
  InputBase,
  Divider,
} from "@mui/material";
import InsertEmoticonIcon from "@mui/icons-material/InsertEmoticon";
import SendIcon from "@mui/icons-material/Send";
import ChatIcon from "@mui/icons-material/Chat";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import CloseIcon from "@mui/icons-material/Close";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import DownloadIcon from "@mui/icons-material/Download";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const ChatBoard = () => {
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [userId, setUserId] = useState(null);
  const [socket, setSocket] = useState(null);
  const [receiverId, setReceiverId] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [groups, setGroups] = useState([]);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const reactQuillRef = useRef(null);

  useEffect(() => {
    const socketInstance = io(BASE_URL);
    setSocket(socketInstance);

    socketInstance.on("newMessage", (messageData) => {
      setMessages((prev) => [...prev, messageData.message]);
    });

    return () => {
      if (socketInstance) socketInstance.disconnect();
    };
  }, []);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const token = sessionStorage.getItem("token");
        const res = await fetch(`${BASE_URL}/api/employees/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error("Error fetching employees");
        setEmployees(await res.json());
      } catch (err) {
        setError("Error fetching employees");
      }
    };

    const fetchGroups = async () => {
      try {
        const token = sessionStorage.getItem("token");
        const res = await fetch(`${BASE_URL}/api/chat/getallgroups`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error("Error fetching groups");
        const data = await res.json();
        setGroups(Array.isArray(data.data) ? data.data : []);
      } catch (err) {
        setError("Error fetching groups");
      }
    };

    fetchEmployees();
    fetchGroups();
  }, []);

  const fetchMessages = async () => {
    if (!receiverId) return;
    setLoading(true);

    try {
      const token = sessionStorage.getItem("token");
      const decoded = jwtDecode(token);
      const senderId = decoded.employee.id;
      const res = await fetch(
        `${BASE_URL}/api/chat/getChat/${senderId}/${receiverId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (!res.ok) throw new Error("Error fetching messages");
      const result = await res.json();
      setMessages(result?.data?.messages || []);
      setUserId(senderId);
    } catch (err) {
      setError("Error fetching chat messages");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMessages();
  }, [receiverId]);

  const sendMessage = async (e) => {
    e.preventDefault();
    setLoading(true);
    const token = sessionStorage.getItem("token");

    try {
      const decoded = jwtDecode(token);
      const senderId = decoded.employee.id;

      if (!senderId || !receiverId || (!newMessage && selectedFiles.length === 0)) {
        throw new Error("Message or files required");
      }

      const formData = new FormData();
      formData.append("senderId", senderId);
      formData.append("receiverId", receiverId);
      formData.append("message", newMessage);
      selectedFiles.forEach((f) => formData.append("files", f));

      const res = await fetch(`${BASE_URL}/api/chat/sendMessage`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      if (!res.ok) throw new Error("Error sending message");
      const data = await res.json();
      if (data?.status === 1) {
        setMessages((prev) => [...prev, data.data]);
        socket.emit("sendMessage", data.data);
      }

      setNewMessage("");
      setSelectedFiles([]);
    } catch (err) {
      setError("Error sending message");
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    setSelectedFiles(Array.from(e.target.files));
  };

  const handleEmojiClick = (emoji) => {
    setNewMessage((prev) => prev + emoji.emoji);
    setShowEmojiPicker(false);
  };

  const formatTime = (t) =>
    t
      ? new Date(t).toLocaleString([], { hour: "2-digit", minute: "2-digit", hour12: true })
      : "";



  const activeChatName =
    employees.find((e) => e._id === receiverId)?.name ||
    groups.find((g) => g._id === receiverId)?.groupName ||
    "Your colleague";

  const activeChatInitial = activeChatName?.charAt(0)?.toUpperCase() || "?";

  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  // Group messages by date for date separators
  const getDateLabel = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    if (date.toDateString() === today.toDateString()) return "Today";
    if (date.toDateString() === yesterday.toDateString()) return "Yesterday";
    return date.toLocaleDateString([], {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  return (
    <>
      <Navbar />
      <Box
        sx={{
          display: "flex",
          height: { xs: "calc(100vh - 56px)", sm: "calc(100vh - 64px)" },
          mt: { xs: "56px", sm: "64px" },
          bgcolor: "#f5f7fb",
          overflow: "hidden",
        }}
      >
        {/* ====== Sidebar ====== */}
        <Box
          sx={{
            width: 320,
            minWidth: 320,
            maxWidth: 320,
            borderRight: "1px solid #eef0f6",
            bgcolor: "#fff",
            overflow: "hidden",
          }}
        >
          <Sideboard
            employees={employees}
            groups={groups}
            onSelectChat={setReceiverId}
            selectedChatId={receiverId}
          />
        </Box>

        {/* ====== Chat Area ====== */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            position: "relative",
          }}
        >
          {receiverId ? (
            <>
              {/* ---- Chat Header ---- */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  px: 3,
                  py: 1.5,
                  bgcolor: "#fff",
                  borderBottom: "1px solid #eef0f6",
                  minHeight: 64,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  <Badge
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    variant="dot"
                    sx={{
                      "& .MuiBadge-badge": {
                        bgcolor: "#44b700",
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        border: "2px solid #fff",
                      },
                    }}
                  >
                    <Avatar
                      sx={{
                        width: 42,
                        height: 42,
                        background:
                          "linear-gradient(135deg, #667eea, #764ba2)",
                        fontWeight: 700,
                        fontSize: "1rem",
                      }}
                    >
                      {activeChatInitial}
                    </Avatar>
                  </Badge>
                  <Box>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: "1rem",
                        color: "#1a1a2e",
                        lineHeight: 1.3,
                      }}
                    >
                      {activeChatName}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "0.75rem",
                        color: "#44b700",
                        fontWeight: 500,
                      }}
                    >
                      Online
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", gap: 0.5 }}>
                  <IconButton
                    sx={{
                      color: "#667eea",
                      "&:hover": { bgcolor: "rgba(102,126,234,0.08)" },
                    }}
                  >
                    <PhoneOutlinedIcon />
                  </IconButton>
                  <IconButton
                    sx={{
                      color: "#667eea",
                      "&:hover": { bgcolor: "rgba(102,126,234,0.08)" },
                    }}
                  >
                    <VideocamOutlinedIcon />
                  </IconButton>
                </Box>
              </Box>

              {/* ---- Messages Area ---- */}
              <Box
                sx={{
                  flex: 1,
                  overflowY: "auto",
                  overflowX: "hidden",
                  px: 3,
                  py: 2,
                  bgcolor: "#f5f7fb",
                  "&::-webkit-scrollbar": { width: "5px" },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#ccc",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    background: "#aaa",
                  },
                }}
              >
                {loading && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      py: 4,
                    }}
                  >
                    <Typography sx={{ color: "#8b8fa3", fontSize: "0.9rem" }}>
                      Loading messages...
                    </Typography>
                  </Box>
                )}
                {error && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      py: 2,
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#e53935",
                        fontSize: "0.85rem",
                        bgcolor: "#ffeef0",
                        px: 2,
                        py: 0.8,
                        borderRadius: "8px",
                      }}
                    >
                      {error}
                    </Typography>
                  </Box>
                )}

                {messages.length > 0 ? (
                  <Stack spacing={1}>
                    {messages.map((m, index) => {
                      const isMe = m.senderId === userId;
                      const currentDate = getDateLabel(m.timestamp);
                      const prevDate =
                        index > 0
                          ? getDateLabel(messages[index - 1].timestamp)
                          : null;
                      const showDateSeparator =
                        index === 0 || currentDate !== prevDate;

                      return (
                        <React.Fragment key={m._id || index}>
                          {/* Date Separator */}
                          {showDateSeparator && currentDate && (
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                my: 1.5,
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "0.7rem",
                                  color: "#8b8fa3",
                                  bgcolor: "#e8ebf0",
                                  px: 2,
                                  py: 0.4,
                                  borderRadius: "12px",
                                  fontWeight: 500,
                                }}
                              >
                                {currentDate}
                              </Typography>
                            </Box>
                          )}

                          {/* Message Bubble */}
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: isMe
                                ? "flex-end"
                                : "flex-start",
                              alignItems: "flex-end",
                              gap: 1,
                            }}
                          >
                            {/* Other user avatar */}
                            {!isMe && (
                              <Avatar
                                sx={{
                                  width: 30,
                                  height: 30,
                                  background:
                                    "linear-gradient(135deg, #667eea, #764ba2)",
                                  fontSize: "0.7rem",
                                  fontWeight: 600,
                                  mb: 0.5,
                                }}
                              >
                                {m.senderName?.charAt(0)?.toUpperCase() || "?"}
                              </Avatar>
                            )}

                            <Box
                              sx={{
                                maxWidth: "65%",
                                minWidth: 80,
                              }}
                            >
                              <Paper
                                elevation={0}
                                sx={{
                                  px: 2,
                                  py:
                                    m.files?.length > 0 && !m.message
                                      ? 1
                                      : 1.5,
                                  background: isMe
                                    ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                    : "#fff",
                                  color: isMe ? "#fff" : "#1a1a2e",
                                  borderRadius: isMe
                                    ? "18px 18px 4px 18px"
                                    : "18px 18px 18px 4px",
                                  overflow: "hidden",
                                  boxShadow: isMe
                                    ? "0 2px 12px rgba(102,126,234,0.25)"
                                    : "0 1px 6px rgba(0,0,0,0.06)",
                                }}
                              >
                                {/* Sender Name */}
                                {!isMe && m.senderName && (
                                  <Typography
                                    sx={{
                                      mb: 0.3,
                                      fontWeight: 700,
                                      fontSize: "0.72rem",
                                      color: "#667eea",
                                    }}
                                  >
                                    {m.senderName}
                                  </Typography>
                                )}

                                {/* Message Body */}
                                {m.message && (
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      fontSize: "0.875rem",
                                      lineHeight: 1.55,
                                      wordBreak: "break-word",
                                      "& p": { m: 0 },
                                    }}
                                    dangerouslySetInnerHTML={{
                                      __html: m.message,
                                    }}
                                  />
                                )}

                                {/* File Attachments */}
                                {m.files?.map((file, idx) => {
                                  const ext = file
                                    .split(".")
                                    .pop()
                                    .toLowerCase();

                                  if (
                                    ["jpg", "jpeg", "png", "gif"].includes(ext)
                                  ) {
                                    return (
                                      <Box
                                        key={idx}
                                        component="img"
                                        src={file}
                                        alt="uploaded"
                                        sx={{
                                          mt: 1,
                                          maxWidth: "100%",
                                          maxHeight: 260,
                                          borderRadius: "12px",
                                          cursor: "pointer",
                                          objectFit: "cover",
                                          display: "block",
                                        }}
                                        onClick={() =>
                                          window.open(file, "_blank")
                                        }
                                      />
                                    );
                                  } else if (
                                    ["mp4", "webm", "ogg"].includes(ext)
                                  ) {
                                    return (
                                      <Box
                                        key={idx}
                                        sx={{
                                          mt: 1,
                                          borderRadius: "12px",
                                          overflow: "hidden",
                                        }}
                                      >
                                        <video
                                          controls
                                          style={{
                                            width: "100%",
                                            borderRadius: "12px",
                                          }}
                                        >
                                          <source
                                            src={file}
                                            type={`video/${ext}`}
                                          />
                                        </video>
                                      </Box>
                                    );
                                  } else {
                                    const fileName =
                                      file.split("/").pop() || "File";
                                    return (
                                      <Box
                                        key={idx}
                                        component="a"
                                        href={file}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        sx={{
                                          mt: 1,
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 1,
                                          px: 1.5,
                                          py: 1,
                                          bgcolor: isMe
                                            ? "rgba(255,255,255,0.15)"
                                            : "#f5f7fb",
                                          borderRadius: "10px",
                                          textDecoration: "none",
                                          color: isMe ? "#fff" : "#1a1a2e",
                                          transition: "background 0.15s",
                                          "&:hover": {
                                            bgcolor: isMe
                                              ? "rgba(255,255,255,0.25)"
                                              : "#eef0f6",
                                          },
                                        }}
                                      >
                                        <DescriptionOutlinedIcon
                                          sx={{ fontSize: 20 }}
                                        />
                                        <Typography
                                          sx={{
                                            flex: 1,
                                            fontSize: "0.8rem",
                                            fontWeight: 500,
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          {fileName}
                                        </Typography>
                                        <DownloadIcon
                                          sx={{ fontSize: 18, opacity: 0.7 }}
                                        />
                                      </Box>
                                    );
                                  }
                                })}

                                {/* Timestamp */}
                                <Typography
                                  sx={{
                                    display: "block",
                                    mt: 0.5,
                                    fontSize: "0.625rem",
                                    color: isMe
                                      ? "rgba(255,255,255,0.6)"
                                      : "#8b8fa3",
                                    textAlign: isMe ? "right" : "left",
                                  }}
                                >
                                  {formatTime(m.timestamp)}
                                </Typography>
                              </Paper>
                            </Box>
                          </Box>
                        </React.Fragment>
                      );
                    })}
                    <div ref={messagesEndRef} />
                  </Stack>
                ) : (
                  !loading && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                        textAlign: "center",
                        color: "#8b8fa3",
                      }}
                    >
                      <Box
                        sx={{
                          width: 80,
                          height: 80,
                          borderRadius: "50%",
                          background:
                            "linear-gradient(135deg, rgba(102,126,234,0.12), rgba(118,75,162,0.12))",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mb: 2.5,
                        }}
                      >
                        <ChatBubbleOutlineIcon
                          sx={{ fontSize: 36, color: "#667eea" }}
                        />
                      </Box>
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: "1.1rem",
                          color: "#1a1a2e",
                          mb: 0.5,
                        }}
                      >
                        No messages yet
                      </Typography>
                      <Typography sx={{ fontSize: "0.85rem", maxWidth: 280 }}>
                        Start a conversation by sending a message below
                      </Typography>
                    </Box>
                  )
                )}
              </Box>

              {/* ---- Input Area ---- */}
              <Box
                component="form"
                onSubmit={sendMessage}
                sx={{
                  bgcolor: "#fff",
                  borderTop: "1px solid #eef0f6",
                  position: "relative",
                }}
              >
                {/* Selected Files Preview */}
                {selectedFiles.length > 0 && (
                  <Box
                    sx={{
                      display: "flex",
                      gap: 1,
                      px: 2,
                      pt: 1.5,
                      pb: 0.5,
                      flexWrap: "wrap",
                      borderBottom: "1px solid #eef0f6",
                    }}
                  >
                    {selectedFiles.map((file, idx) => {
                      const ext = file.name.split(".").pop().toLowerCase();
                      const isImage = ["jpg", "jpeg", "png", "gif"].includes(
                        ext
                      );
                      return (
                        <Box
                          key={idx}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.8,
                            bgcolor: "#f5f7fb",
                            border: "1px solid #eef0f6",
                            borderRadius: "10px",
                            px: 1.2,
                            py: 0.6,
                            maxWidth: 180,
                          }}
                        >
                          {isImage ? (
                            <Box
                              component="img"
                              src={URL.createObjectURL(file)}
                              alt={file.name}
                              sx={{
                                width: 32,
                                height: 32,
                                objectFit: "cover",
                                borderRadius: "6px",
                              }}
                            />
                          ) : (
                            <DescriptionOutlinedIcon
                              sx={{ fontSize: 20, color: "#667eea" }}
                            />
                          )}
                          <Typography
                            sx={{
                              fontSize: "0.75rem",
                              fontWeight: 500,
                              color: "#1a1a2e",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              flex: 1,
                            }}
                          >
                            {file.name}
                          </Typography>
                          <IconButton
                            size="small"
                            onClick={() =>
                              setSelectedFiles((prev) =>
                                prev.filter((_, i) => i !== idx)
                              )
                            }
                            sx={{ p: 0.3 }}
                          >
                            <CloseIcon sx={{ fontSize: 14, color: "#8b8fa3" }} />
                          </IconButton>
                        </Box>
                      );
                    })}
                  </Box>
                )}

                {/* Emoji Picker */}
                {showEmojiPicker && (
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: "100%",
                      left: 16,
                      mb: 1,
                      zIndex: 10,
                      boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
                      borderRadius: "12px",
                      overflow: "hidden",
                    }}
                  >
                    <EmojiPicker
                      onEmojiClick={handleEmojiClick}
                      width={320}
                      height={380}
                    />
                  </Box>
                )}

                {/* Input Row */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    px: 1.5,
                    py: 1.2,
                  }}
                >
                  {/* Emoji Toggle */}
                  <IconButton
                    onClick={() => setShowEmojiPicker((prev) => !prev)}
                    sx={{
                      color: showEmojiPicker ? "#667eea" : "#8b8fa3",
                      "&:hover": { color: "#667eea" },
                    }}
                  >
                    <InsertEmoticonIcon />
                  </IconButton>

                  {/* Attach File */}
                  <IconButton
                    component="label"
                    sx={{
                      color: "#8b8fa3",
                      "&:hover": { color: "#667eea" },
                    }}
                  >
                    <AttachFileIcon sx={{ transform: "rotate(45deg)" }} />
                    <input
                      type="file"
                      multiple
                      hidden
                      onChange={handleFileChange}
                    />
                  </IconButton>

                  {/* Text Input */}
                  <Box
                    sx={{
                      flex: 1,
                      bgcolor: "#f5f7fb",
                      borderRadius: "24px",
                      px: 2,
                      py: 0.8,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <InputBase
                      placeholder="Type a message..."
                      value={newMessage}
                      onChange={(e) => setNewMessage(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && !e.shiftKey) {
                          e.preventDefault();
                          if (newMessage.trim() || selectedFiles.length > 0) {
                            sendMessage(e);
                          }
                        }
                      }}
                      multiline
                      maxRows={4}
                      sx={{
                        flex: 1,
                        fontSize: "0.9rem",
                        color: "#1a1a2e",
                        "& ::placeholder": {
                          color: "#8b8fa3",
                          opacity: 1,
                        },
                      }}
                    />
                  </Box>

                  {/* Send Button */}
                  <IconButton
                    type="submit"
                    disabled={
                      loading ||
                      (!newMessage.trim() && selectedFiles.length === 0)
                    }
                    sx={{
                      width: 44,
                      height: 44,
                      background:
                        !newMessage.trim() && selectedFiles.length === 0
                          ? "#e0e3eb"
                          : "linear-gradient(135deg, #667eea, #764ba2)",
                      color: "#fff",
                      "&:hover": {
                        background:
                          "linear-gradient(135deg, #5a6fd6, #6a4298)",
                      },
                      "&.Mui-disabled": {
                        color: "#b0b5c3",
                        background: "#e0e3eb",
                      },
                      transition: "all 0.2s ease",
                      boxShadow:
                        newMessage.trim() || selectedFiles.length > 0
                          ? "0 3px 12px rgba(102,126,234,0.35)"
                          : "none",
                    }}
                  >
                    <SendIcon sx={{ fontSize: 20, ml: 0.3 }} />
                  </IconButton>
                </Box>
              </Box>
            </>
          ) : (
            /* ---- Empty State (no chat selected) ---- */
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "#f5f7fb",
                textAlign: "center",
              }}
            >
              <Box
                sx={{
                  width: 120,
                  height: 120,
                  borderRadius: "50%",
                  background:
                    "linear-gradient(135deg, rgba(102,126,234,0.1), rgba(118,75,162,0.1))",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 3,
                }}
              >
                <ChatBubbleOutlineIcon
                  sx={{ fontSize: 52, color: "#667eea" }}
                />
              </Box>
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: "1.4rem",
                  color: "#1a1a2e",
                  mb: 1,
                }}
              >
                Welcome to HRMS Chat
              </Typography>
              <Typography
                sx={{ fontSize: "0.95rem", color: "#8b8fa3", maxWidth: 360 }}
              >
                Select a conversation from the sidebar to start messaging your
                team
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};

export default ChatBoard;